$(() => {
  if ($(".layout-places_create .error").length < 1) {
    return
  }

  const field = $(".error").first().closest(".places-form-i-controls")
  Viewport.scrollTo(field)
  const input = field.find("input, select").filter((_, el) => HB.isVisible(el))
  if (input.length > 0) {
    input.first().trigger("focus")
  }
})
